import { useToast } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import React, { useEffect } from 'react';

import { useStores } from '../hooks/useStores';

const useStoreData = () => {
    const { store } = useStores();
    return useObserver(() => ({
        alerts: Array.from(store.alerts.list.values()),
        remove: store.alerts.remove,
    }));
};

const Toast = () => {
    const toast = useToast();
    const { alerts, remove } = useStoreData();
    useEffect(() => {
        if (alerts.length) {
            alerts.forEach(alert => {
                toast({
                    title: alert.title,
                    description: alert.description,
                    status: alert.type,
                    duration: 5000,
                    isClosable: true,
                    position: 'bottom-right',
                    onClose: () => {
                        console.log('closing toast'); // this line never runs
                    },
                });
                remove(alert);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alerts]);

    return <></>;
};

export default Toast;
